import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { PkCommonHeader } from "../../../components/common/PkCommonHeader";
const Header = ({ login }) => {
  return (
    <Box
      sx={{
        pb: "8rem",
        flexGrow: 1,
        width: "100%",
        minHeight: "800px",
        backgroundColor: "#000",
        backgroundImage: `linear-gradient(80deg, #222222ff 20%, transparent),url(${"https://website-img.polycaik.com/w/asset/41e9421f20d244fc9876d447d1a236d1.jpg"})`,
        backgroundPosition: {
          xs: `center, center`,
          md: `left center, left center`,
          lg: `left -100%  center, left -100% center`,
        },
      }}
    >
      {((sx = { px: "10%" }) => (
        <>
          <PkCommonHeader hero={true} color={`white`} />
          <Box
            sx={{
              ...sx,
              width: "100%",
              maxWidth: "900px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                mt: 3,
                mb: 2,
                "& span": {
                  color: "primary.main",
                  fontFamily: "Lato-Bold",
                },
              }}
              textTransform="uppercase"
              fontFamily="Lato-Regular"
              lineHeight={1.5}
            >
              Game <span>design software</span> for the creative
            </Typography>
            <Typography sx={{ pr: 2 }} variant="body1" lineHeight={2}>
              The playing field is far from even. Some have access to funding,
              while others don't. Some narratives are portrayed again and again,
              while others aren't. That's why we created Polycaik, an
              AI-assisted game development suite that opens new doors for
              creators who believe representation matters
            </Typography>
            <Button
              sx={{ mt: 3, p: 1, maxWidth: "300px" }}
              variant="contained"
              href={`/developers`}
            >
              LEARN MORE
            </Button>
          </Box>
        </>
      ))()}
    </Box>
  );
};
export default Header;
